"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NamespacedNamed_1 = require("../NamespacedNamed");
const typeDefs_1 = require("./typeDefs");
class TypeSystem {
    constructor() {
        this.knownTypes = new Map();
    }
    getType(name) {
        const k = this.knownTypes.get(name.toString());
        return k;
    }
    getOrCreateType(name) {
        let k = this.knownTypes.get(name.toString());
        if (!k) {
            k = new TypeDefinition(name, undefined);
            this.knownTypes.set(name.toString(), k);
        }
        return k;
    }
    isTypeKnown(name) {
        return !!this.knownTypes.get(name.toString());
    }
    defineType(name, definition) {
        this.getOrCreateType(name).updateDefinition(definition);
    }
    definedNamespaces() {
        const namespaces = new Set();
        for (const t of this.knownTypes.values()) {
            namespaces.add(t.namespacedName.namespace);
        }
        return [...namespaces].map(ns => NamespacedNamed_1.namespace(ns));
    }
    toPackage(ns) {
        const definitions = {};
        for (const type of this.knownTypes.values()) {
            if (type.namespacedName.namespace === ns.namespace) {
                definitions[type.namespacedName.name] = type.definition.toTypeDef();
            }
        }
        const result = new typeDefs_1.TypePackageDef(ns, definitions);
        return result;
    }
    definedPackages() {
        const result = new Array();
        for (const ns of this.definedNamespaces()) {
            result.push(this.toPackage(ns));
        }
        return result;
    }
}
exports.TypeSystem = TypeSystem;
class BaseType {
    resolveUnion() {
        return [this];
    }
    resolveDefinition() {
        return this;
    }
}
exports.BaseType = BaseType;
class TypeDefinition extends BaseType {
    constructor(namespacedName, definition) {
        super();
        this.namespacedName = namespacedName;
        this.kind = "definition";
        this._definition = definition;
    }
    get isDefined() {
        return !!this._definition;
    }
    get definition() {
        if (!this._definition) {
            throw new Error("no definition");
        }
        return this._definition;
    }
    updateDefinition(newDefinition) {
        this._definition = newDefinition;
    }
    resolveUnion() {
        const u = this.definition.resolveUnion();
        if (u.length > 1) {
            return u;
        }
        return [this];
    }
    resolveDefinition() {
        return this.definition.resolveDefinition();
    }
    toTypeDef() {
        return new typeDefs_1.TypeRefDef(this.namespacedName);
    }
}
exports.TypeDefinition = TypeDefinition;
class CustomType extends BaseType {
    constructor(type) {
        super();
        this.type = type;
        this.kind = "custom";
    }
    toTypeDef() {
        throw new Error("Not implemneted");
    }
}
exports.CustomType = CustomType;
class UnionType extends BaseType {
    constructor(of) {
        super();
        this.of = of;
        this.kind = "union";
    }
    toTypeDef() {
        return new typeDefs_1.UnionTypeDef(this.of.map(t => t.toTypeDef()));
    }
    resolveUnion() {
        return new Array().concat(...this.of.map(t => t.resolveUnion()));
    }
}
exports.UnionType = UnionType;
class IntersectionType extends BaseType {
    constructor(of) {
        super();
        this.of = of;
        this.kind = "intersection";
    }
    toTypeDef() {
        return new typeDefs_1.IntersectionTypeDef(this.of.map(t => t.toTypeDef()));
    }
}
exports.IntersectionType = IntersectionType;
class StringType extends BaseType {
    constructor() {
        super(...arguments);
        this.kind = "string";
    }
    toTypeDef() {
        return new typeDefs_1.StringTypeDef();
    }
}
exports.StringType = StringType;
class NumberType extends BaseType {
    constructor() {
        super(...arguments);
        this.kind = "number";
    }
    toTypeDef() {
        return new typeDefs_1.NumberTypeDef();
    }
}
exports.NumberType = NumberType;
class AnyType extends BaseType {
    constructor() {
        super(...arguments);
        this.kind = "any";
    }
    toTypeDef() {
        return new typeDefs_1.AnyTypeDef();
    }
}
exports.AnyType = AnyType;
class BooleanType extends BaseType {
    constructor() {
        super(...arguments);
        this.kind = "boolean";
    }
    toTypeDef() {
        return new typeDefs_1.BooleanTypeDef();
    }
}
exports.BooleanType = BooleanType;
class LiteralType extends BaseType {
    constructor(value) {
        super();
        this.value = value;
        this.kind = "literal";
    }
    toTypeDef() {
        return new typeDefs_1.LiteralTypeDef(this.value);
    }
}
exports.LiteralType = LiteralType;
class ObjectType extends BaseType {
    constructor(properties) {
        super();
        this.properties = properties;
        this.kind = "object";
    }
    toTypeDef() {
        return new typeDefs_1.ObjectTypeDef(Object.fromEntries(Object.entries(this.properties).map(([name, prop]) => [
            name,
            prop.toObjectPropertyDef(),
        ])));
    }
}
exports.ObjectType = ObjectType;
class ObjectProperty {
    constructor(name, type, optional, defaultValue) {
        this.name = name;
        this.type = type;
        this.optional = optional;
        this.defaultValue = defaultValue;
    }
    toObjectPropertyDef() {
        return new typeDefs_1.ObjectPropertyDef(this.type.toTypeDef(), this.optional, this.defaultValue);
    }
}
exports.ObjectProperty = ObjectProperty;
class MapType extends BaseType {
    constructor(valueType) {
        super();
        this.valueType = valueType;
        this.kind = "map";
    }
    toTypeDef() {
        return new typeDefs_1.MapTypeDef(this.valueType.toTypeDef());
    }
}
exports.MapType = MapType;
class ArrayType extends BaseType {
    constructor(itemType) {
        super();
        this.itemType = itemType;
        this.kind = "array";
    }
    toTypeDef() {
        return new typeDefs_1.ArrayTypeDef(this.itemType.toTypeDef());
    }
}
exports.ArrayType = ArrayType;
//# sourceMappingURL=types.js.map